export const STATIC_BUCKET_PATH =
    "https://klasha-public-assets.s3.eu-west-3.amazonaws.com";

export enum API_ROUTES {
    GET_ALL_WALLET_TRANSACTIONS = "/wallet/admin/transaction/paginated/filter",
    GET_WALLET_CURRENCY_TRANSACTIONS = "/wallet/admin/transaction/paginated/filter",
    GET_WALLET_DEPOSIT_REQUESTS = "/wallet/funding/business/wallet/v2/filter/paginated",
    UPDATE_WALLET_DEPOSIT_REQUEST = "/wallet/funding/business/wallet/update/payment/status/",
    GET_SETTLEMENTS_PAYIN_DETAILS = "/wallet/virtual/account/collection/filter/paginated",
    GET_SETTLEMENTS_PAYOUT_DETAILS = "/wallet/foreign/banktransfer/request/admin/transaction/paginated/filter",
    GET_VIRTUAL_ACCOUNT_TRANSACTIONS = "/nucleus/virtual/account/collections/filter/paginated",
    GET_CUSTOMER_PAYMENT_LINKS = "/merchant/paylink/business",
    DELETE_CUSTOMER_PAYMENT_LINK = "/merchant/paylink/delete",
    SHARE_CUSTOMER_LINK = "/merchant/paylink/share",
    GET_KLASHA_WIRE_PAYMENTS = "/merchant/bulkmerchantpayment/admin/paginated/filter",
    GET_EXCHANGE_RATES = "/nucleus/general/exchange/all/v2",
    GET_RATE = "/nucleus/general/exchange",
    GET_ALL_REFUNDS = "/nucleus/refund/filter/paginated",
    GET_ALL_TRANSACTIONS = "/nucleus/tnx/paginated/filter",
    GET_ALL_CUSTOMERS = "/wallet/virtual/v2/filter/paginated",
    GET_ALL_PAYIN_COLLECTIONS = "nucleus/tnx/filter/paginated",
    GET_ALL_PAYOUT_COLLECTIONS = "wallet/withdraw/merchant/request/admin/transaction/paginated/filter",
    INITIATE_TRANSACTIONS_EXPORT_CACHE = "/nucleus/tnx/export",
    DISPATCH_TRANSACTIONS_EXPORT_TO_EMAIL = "nucleus/tnx/export",
    EXPORT_COLLECTION_STATEMENT = "/wallet/account/statement/export",
    EXPORT_WALLET_STATEMENT = "/wallet/wallet/statement/export",
    CREATE_STABLE_COIN_WALLET = "wallet/stable-coin/create-wallet",
    GET_STABLE_COIN_WALLET_ADDRESS = "wallet/stable-coin/get-wallet",
    GET_STABLE_COIN_NETWORKS = "wallet/stable-coin/b2c/networks",
    STABLE_COIN_PAYOUT = "wallet/stable-coin/v2/create-payout",
    CREATE_STABLE_COIN_SWAP = "wallet/stable-coin/create-swap",
    CONFIRM_STABLE_COIN_SWAP = "wallet/stable-coin/confirm-swap",
    GET_STABLE_COIN_FEE = "wallet/stable-coin/fees",
    GET_NOTIFICATIONS = "/merchant/notifications",
    GET_NOTIFICATIONS_UNREAD_COUNT = "/merchant/notifications/unread-count",
    MARK_ALL_NOTIFICATIONS_READ = "/merchant/notifications/read-all",
    MERCHANT_BASIC_SETTINGS = "/merchant/basic/settings",
    GET_RECEIPT_PAYOUT = "/merchant/receipts/payout",
    GET_RECEIPT_BANK_TRANSFER = "/merchant/receipts/bank-transfer",
    GET_RECEIPT_KLASHA_WIRE = "/merchant/receipts/klasha-wire",
}

export const DEFAULT_STALE_TIME = 5 * 60 * 1000;
export const DEFAULT_CACHE_TIME = 10 * 60 * 1000;

export const TRANSACTIONS_TIMEOUT = 120000;

export const MINIMUM_USD = process.env.REACT_APP_ENV === "dev" ? 1 : 100;

export const PHONE_REGEX = /^[+]?[\d\s\-().]{7,15}$/;
export const EMAIL_REGEX = /^[\w.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;


export const documentTooltipInfo = {
    "CAC status report": "A document that shows your company's CAC registration and compliance status.",
    "Certificate of Incorporation": "An official document confirming your company’s legal incorporation.",
    "Constitution/Board Charter": "A document outlining the governance structure, rules, and responsibilities of the company’s board.",
    "Director and owner valid ID": "A government-issued identification of company directors and owners for verification.",
    "Incorporated Documents": "Official documents filed during company incorporation",
    "Memorandum and articles of association": "A legal document defining the company’s objectives, structure, and internal rules.",
    "Proof of business address": "A document confirming the registered address of the business, issued between the last 3 - 6 months.",
    "Tax identification certificate": "An official certificate confirming the company’s registered Tax Identification Number.",
    "KRA tax certificate or copy of CR12": "An official KRA tax compliance certificate or CR12 form showing company ownership details."
}

/* Temporarily hardcode specific emails and confirm if posthog can support this*/
export const STATIC_MERCHANT_EMAILS = [
    "fadeniji@klasha.com",
    "admin@terri.name.ng",
    "tochukwu.ubani@gmail.com",
    "payments@atlasremit.com",
    "stephen@klasha.com",
    "odochi@klasha.com",
    "odochiokara@gmail.com",
    "romokeoladejo+62@gmail.com",
    "klashazar@gmail.com",
    "romokeoladejo+67@gmail.com",
    "romokeoladejo+81@gmail.com ",
    "patouossa@mounir-holding.com",
    "sahil.handa@inmobi.com",
    "sanmita.d@inmobi.com",
    "admin@varilus.com",
    "tahbuhhq@gmail.com",
    "developer@bsmglb.be.gov.ng",
    "faitharika10@gmail.com",
    "support@ahfgrants.com"
];

export const GHS_SEND_ALLOW_LIST = [
    "fadeniji@klasha.com",
    "feyikemi@klasha.comm",
    "feyikemi@klasha.com",
    "odochiokara@gmail.com",
    "frenoippennatrou-4655@yopmail.com",
    "partnersmsb@transfi.com"
]